import { render, staticRenderFns } from "./PayContent.vue?vue&type=template&id=6af136e3&scoped=true&"
import script from "./PayContent.vue?vue&type=script&lang=js&"
export * from "./PayContent.vue?vue&type=script&lang=js&"
import style0 from "./PayContent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PayContent.vue?vue&type=style&index=1&id=6af136e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af136e3",
  null
  
)

export default component.exports